import { ReactNode } from 'react'
import { Role } from '$api-client/types.gen'
import { useAuth } from '$features/auth/hooks/use-auth'
import { PermissionsHelper } from '$utils/permissions'
import { Navigate } from 'react-router'

export type RequireRoleProps = {
  roles: Role[]
  children: ReactNode
  fallback?: ReactNode
  redirectTo?: string
}

export function RequireRole({ roles, children, fallback, redirectTo }: RequireRoleProps) {
  const { user } = useAuth()
  const hasRole = PermissionsHelper.hasRole(user.role, roles)

  if (!hasRole) {
    if (redirectTo) {
      return <Navigate
        to={redirectTo}
        replace
      />
    }

    return fallback ?? null
  }

  return children
}
